export const REPORTS_HARVEST_INSPECTIONS_LOAD_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_LOAD_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_LOAD_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_LOAD_SUCCEEDED';
export const REPORTS_HARVEST_INSPECTIONS_LOAD_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_LOAD_FAILED';

export const REPORTS_HARVEST_INSPECTIONS_POLLING_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_POLLING_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_POLLING_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_POLLING_CANCELED =
    'REPORTS_HARVEST_INSPECTIONS_POLLING_CANCELED';

export const REPORTS_HARVEST_INSPECTIONS_EXPORT_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_EXPORT_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_EXPORT_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_EXPORT_SUCCEEDED';
export const REPORTS_HARVEST_INSPECTIONS_EXPORT_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_EXPORT_FAILED';

export const REPORTS_HARVEST_INSPECTIONS_SET =
    'REPORTS_HARVEST_INSPECTIONS_SET';
export const REPORTS_HARVEST_INSPECTIONS_MERGE =
    'REPORTS_HARVEST_INSPECTIONS_MERGE';
export const REPORTS_HARVEST_INSPECTION_SET = 'REPORTS_HARVEST_INSPECTION_SET';
